import { Stack, TextField, Typography } from "@mui/material";
import * as React from "react";
import QueryStatsIcon from "@mui/icons-material/QueryStats";

const TemplateItemSearch = ({ setSearchItemQuery }) => {
    const handleSearchInput = (event) => {
        if (event.target.value === "") {
            setSearchItemQuery("");
        } else {
            setSearchItemQuery(event.target.value);
        }
    };
    return (
        <TextField
            onChange={handleSearchInput}
            type="search"
            id="search-item"
            size="small"
            label={
                <Stack direction="row" spacing={1}>
                    <QueryStatsIcon fontSize="small" />
                    <Typography sx={{ fontSize: 12 }}>Search item</Typography>
                </Stack>
            }
            variant="outlined"
        />
    );
};

export default TemplateItemSearch;
